import { axiosAuth } from "./axiosInstances";
import { store } from "../redux/store"; // Importar el store de Redux

// KHAN-240: UserPoints/api/user-points/... (doble prefijo) se migra a
// user-points/... (prefijo unico api/user-points/, agregado por BASE_URL).
// Ver funread_backend/apps/user_points/views.py para el mapping completo
// old -> new.

export const getUserPoints = async (userId) => {
  try {
    const response = await axiosAuth().get(`user-points/${userId}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user points:", error);
    throw error;
  }
};

export const addPointsToUser = async (userId, points) => {
  try {
    const response = await axiosAuth().post(
      `user-points/${userId}/add/`,
      { points }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding points to user:", error);
    throw error;
  }
};

export const getLeaderboard = async () => {
  try {
    const response = await axiosAuth().get(`user-points/leaderboard/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching top ten:", error);
    throw error;
  }
}

export const getCurrentRank = async (userId) => {
  try {
    const response = await axiosAuth().get(`user-points/${userId}/ranking/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching current rank:", error);
    throw error;
  }
};
